import { BaseError } from '@kiplin/web-common/error';

export class MissingSelectedClientForClientGamesReloadError extends BaseError {
  public constructor() {
    super('8e961c3f-a3c0-4e8d-b438-0cb227964b48', 'Unable to reload games because no client is selected');
  }
}
